import { useEffect, useState, type RefObject } from 'react';

export function IsScrolledToBottom(props: {
	children: (scrolledToBottom: boolean) => React.ReactNode;
	dialogRef: RefObject<HTMLDivElement | null>;
}) {
	const [scrolledToBottom, setScrolledToBottom] = useState(true);

	const setScrolledToBottomState = ({ scrollTop, scrollHeight, offsetHeight }: HTMLDivElement) => {
		// Add 80px of margin to action the scrolledToBottom
		setScrolledToBottom(80 + scrollTop >= scrollHeight - offsetHeight);
	};

	useEffect(() => {
		if (!props.dialogRef.current) return;

		const handleScroll = (event: Event) => {
			if (!event.currentTarget) return;
			setScrolledToBottomState(event.currentTarget as HTMLDivElement);
		};

		const dialogElement = props.dialogRef.current;
		dialogElement.addEventListener('scroll', handleScroll);
		handleScroll({ currentTarget: dialogElement } as unknown as Event);
		return () => dialogElement?.removeEventListener('scroll', handleScroll);
	}, [props.dialogRef]);

	return props.children(scrolledToBottom);
}
